import Link from 'next/link';

export interface StoneGuideCTAProps {
  locale: string;
  title?: string;
  subtitle?: string;
  buttonLabel?: string;
}

export function StoneGuideCTA({
  locale,
  title,
  subtitle,
  buttonLabel,
}: StoneGuideCTAProps) {
  const copy =
    locale === 'fr'
      ? {
          title: title ?? 'Besoin de conseils personnalisés ?',
          subtitle:
            subtitle ??
            'Notre équipe vous accompagne à chaque étape de votre projet immobilier à Maurice ou en Provence.',
          button: buttonLabel ?? 'Nous contacter',
        }
      : {
          title: title ?? 'Need personalised advice?',
          subtitle:
            subtitle ??
            'Our team supports you at every stage of your property journey in Mauritius or Provence.',
          button: buttonLabel ?? 'Contact us',
        };

  const href = `/${locale}/contact?intent=consultation`;

  return (
    <section className="bg-stone-900 text-stone-100 py-20 md:py-24">
      <div className="container mx-auto max-w-3xl px-6 md:px-12 text-center">
        <h2
          className="font-serif text-3xl md:text-5xl italic mb-6 leading-tight"
          style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
        >
          {copy.title}
        </h2>
        <p className="font-sans text-stone-300 font-light leading-relaxed mb-10 max-w-xl mx-auto">
          {copy.subtitle}
        </p>
        <Link
          href={href}
          className="inline-block px-12 py-5 bg-white text-stone-900 text-xs uppercase tracking-widest font-sans hover:bg-stone-200 transition-all duration-500 shadow-2xl"
        >
          {copy.button}
        </Link>
      </div>
    </section>
  );
}

export default StoneGuideCTA;
